import React from "react";

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row py-4 align-items-center">
          <div className="col-md-6 text-center text-md-left mb-3 mb-md-0">
            <span className="footer-logo">DataCode</span>
            <p className="footer-text mb-0 mt-2">
              Empowering learners through high-quality structured coding challenges and bootcamps.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-right">
            <p className="footer-copyright mb-0">
              &copy; {new Date().getFullYear()} DataCode. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
